var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { DatePicker } from 'antd';
import moment from 'moment';
import styled, { css, ThemeProvider } from "styled-components";
import { Body1, Heading3 } from "../doconHeadings/doconHeadings";
import Label from '../../shared/InputLabel';
import Error from '../../shared/WidgetError';
import { BaseBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
import 'antd/lib/date-picker/style/css';
var RangePicker = DatePicker.RangePicker;
// Elements
var Title = styled(Heading3)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SubTitle = styled(Body1)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var commonStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  border-radius: 8px;\n  padding: ", ";\n  --inp-align: left;\n  background: var( --inp-bg-color);\n  transition : all 1s;\n  border-color: var(--inp-border-color);\n\n  :focus-within {\n    outline: none;\n    border-color: var(--inp-focus-border-color);\n  }\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    };\n  }\n\n  input {\n    text-align: var(--inp-align);\n  }\n\n  &.ant-picker-focused {\n    box-shadow: none;\n  }\n"], ["\n  ", ";\n  border-radius: 8px;\n  padding: ", ";\n  --inp-align: left;\n  background: var( --inp-bg-color);\n  transition : all 1s;\n  border-color: var(--inp-border-color);\n\n  :focus-within {\n    outline: none;\n    border-color: var(--inp-focus-border-color);\n  }\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    };\n  }\n\n  input {\n    text-align: var(--inp-align);\n  }\n\n  &.ant-picker-focused {\n    box-shadow: none;\n  }\n"])), function (props) { return getColors(props); }, function (props) { return props.size === 'small' ? '5px 10px' : '6.43px 12px'; }, function (props) { return (props.theme.v2.colors.input.hoverBgColor); });
var getColors = function (props) {
    var _a = props.theme.v2.colors.input, color = _a.color, bgColor = _a.bgColor, borderColor = _a.borderColor, placeholderColor = _a.placeholderColor, focusBorderColor = _a.focusBorderColor;
    return "\n    " + (color ? "--inp-color: " + color + ";" : '') + "\n    " + (bgColor ? "--inp-bg-color: " + bgColor + ";" : '') + "\n    " + (borderColor ? "--inp-border-color: " + borderColor + ";" : '') + "\n    " + (placeholderColor ? "--inp-placeholder-color: " + placeholderColor + ";" : '') + "\n    " + (focusBorderColor ? "--inp-focus-border-color: " + focusBorderColor + ";" : '') + "\n    " + (props.error ? " --inp-border-color: #e02020;--inp-focus-border-color:#e02020;" : '') + "\n  ";
};
var RangePickerStyled = styled(RangePicker)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), commonStyle);
var DatePickerStyled = styled(DatePicker)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ";"], ["", ";"])), commonStyle);
function DoconDatePicker(_a) {
    var disableFuture = _a.disableFuture, selectsRange = _a.selectsRange, _b = _a.allowClear, allowClear = _b === void 0 ? false : _b, rootClassName = _a.rootClassName, name = _a.name, label = _a.label, title = _a.title, subtext = _a.subtext, error = _a.error, minDate = _a.minDate, maxDate = _a.maxDate, _c = _a.size, size = _c === void 0 ? 'large' : _c, onChange = _a.onChange, props = __rest(_a, ["disableFuture", "selectsRange", "allowClear", "rootClassName", "name", "label", "title", "subtext", "error", "minDate", "maxDate", "size", "onChange"]);
    function handleChange(value, dateString) {
        onChange && onChange({ name: name, value: value, dateString: dateString });
    }
    ;
    function disabledDate(current) {
        if (minDate)
            return current && current < moment(minDate).startOf('day');
        if (maxDate)
            return current && current > moment(maxDate).endOf('day');
        if (disableFuture)
            // Can not select days after today
            return current && current > moment().endOf('day');
        return false;
    }
    var Node = selectsRange ? RangePickerStyled : DatePickerStyled;
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(BaseBox, { className: rootClassName },
            React.createElement(Title, { title: title }),
            React.createElement(SubTitle, { title: subtext }),
            React.createElement(Label, { label: label, mb: size === 'small' ? '5px' : '8px' }),
            React.createElement(Node, __assign({ allowClear: allowClear, size: size, error: error, disabledDate: disabledDate, onChange: handleChange }, props)),
            React.createElement(Error, { error: error }))));
}
;
export default styled(DoconDatePicker)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
